module.exports = __webpack_public_path__ + "static/media/allergies-icon.5c560785.svg";